"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearQueryParam = exports.getQueryParam = void 0;
const getQueryParam = (name) => {
    let param, url = new URL(window.location.href);
    param = url.searchParams.get(name);
    return param ? decodeURI(param) : null;
};
exports.getQueryParam = getQueryParam;
const clearQueryParam = () => {
    const url = window.location.href;
    const newUrl = url.substring(0, url.indexOf('?'));
    history.pushState('', '', newUrl);
};
exports.clearQueryParam = clearQueryParam;
